import { render, staticRenderFns } from "./OujdaFoodDashboardSidebar.vue?vue&type=template&id=d29abf92&scoped=true&"
import script from "./OujdaFoodDashboardSidebar.vue?vue&type=script&lang=js&"
export * from "./OujdaFoodDashboardSidebar.vue?vue&type=script&lang=js&"
import style0 from "./OujdaFoodDashboardSidebar.vue?vue&type=style&index=0&id=d29abf92&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d29abf92",
  null
  
)

export default component.exports